import {Injectable} from '@angular/core';
import {IOrderHistoryView, IOrderHistoryViewProduct} from '../orders-models';
import {map} from 'rxjs/operators';
import {IProductLine} from '../../cart/cart-models';
import {CartService} from '../../cart/cart.service';
import * as _ from 'lodash';
import {AlertUtilService} from '../../alert/alert-util.service';
import {IProduct} from "../../product/product-models";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {OrderHistoryTrackingComponent} from "../order-history-tracking/order-history-tracking.component";
import {CartUtil} from "../../cart/cart-util";
import {OrderHistoryCacheService} from "./order-history-cache.service";

@Injectable({
	providedIn: 'root'
})
export class OrderHistoryService {

	constructor(
		private cartService: CartService,
        public modalService: BsModalService,
        private orderHistoryCacheService: OrderHistoryCacheService,
		private alertUtilService: AlertUtilService) {
	}

    addItemToCart(product: IOrderHistoryViewProduct, orderId: number) {
        const productCopy = { ...product };
        productCopy.quantity = 1;
        this.addFullOrderToCart([productCopy], orderId);
    }

    addFullOrderToCart(orderViewProducts: IOrderHistoryViewProduct[], orderId: number) {
        const productViewsToAdd = orderViewProducts.filter(orderViewProduct => this.canAddProduct(orderViewProduct));
        const hasUnavailableProducts = productViewsToAdd.length !== orderViewProducts.length;
        this.adjustQuantityForProducts(productViewsToAdd, [], hasUnavailableProducts, orderId);
    }

    openTrackingModal(orderView: IOrderHistoryView) {
        const initialStatus = { orderView };
        const modalRef: BsModalRef = this.modalService.show(OrderHistoryTrackingComponent, Object.assign({}, { initialState: initialStatus }));
        const orderTrackingComponent: OrderHistoryTrackingComponent = modalRef.content;
        orderTrackingComponent.onClose.subscribe(() => modalRef.hide());
    }

    getTrackingCount(orderView: IOrderHistoryView): number {
        return orderView ? CartUtil.getTrackingCount(orderView.packslips) : 0;
    }

	toProduct(viewProduct: IOrderHistoryViewProduct) {
        const product: IProduct = {
            id: viewProduct.id,
            price: {
                price: viewProduct.price,
                volume: viewProduct.volume
            },
            productDescription: {
                name: viewProduct.name,
                fullDisplayName: viewProduct.name
            }
        };
		return product;
	}

	getProductAddedToCart(tempProduct: IProduct, orderViewProduct: IOrderHistoryViewProduct): IProductLine {
		const addedLine: IProductLine = {} as IProductLine;
		let predicate: any;

		if (orderViewProduct.mhpId) {
			predicate = { mhpId: orderViewProduct.mhpId };
		} else {
			predicate = { product: { id: orderViewProduct.id } };
		}

		const addedProduct = _.find(this.cartService.cart.products, predicate);

		if (addedProduct) {
			tempProduct.productDescription.name = addedProduct.product.productDescription.name;
			tempProduct.productDescription.fullDisplayName = addedProduct.product.productDescription.fullDisplayName;
		}

		addedLine.quantity = orderViewProduct.quantity;
		addedLine.product = tempProduct;
		return addedLine;
	}

    adjustQuantityForProducts(productViewsToAdd: IOrderHistoryViewProduct[], productLines: IProductLine[], hasUnavailableProducts: boolean, orderId: number, index?: number) {
        index = index || 0;

        if (index <= productViewsToAdd.length - 1) {
            const productViewToAdd = productViewsToAdd[index];
            this.adjustQuantity(this.toProduct(productViewToAdd), productViewToAdd, productLines).subscribe({
                next: () => {
                    this.orderHistoryCacheService.removeProductAdding(productViewToAdd, orderId);
                    this.adjustQuantityForProducts(productViewsToAdd, productLines, hasUnavailableProducts, orderId, index + 1);
                },
                error: () => this.orderHistoryCacheService.removeProductAdding(productViewToAdd, orderId)
            });
        } else {
            this.orderHistoryCacheService.removeAllProductsAdding();
            this.handleProductAddedAlert(hasUnavailableProducts, productLines);
        }
    }

	adjustQuantity(product: IProduct, orderViewProduct: IOrderHistoryViewProduct, products: IProductLine[]) {
        return this.cartService.adjustCartQuantity(product, orderViewProduct.quantity, orderViewProduct.mhpId).pipe(
            map((success) => {
                if (success) {
                    const productAddedToCart = this.getProductAddedToCart(product, orderViewProduct);
                    products.push(productAddedToCart);
                }

                return success;
            })
        );
	}

	canAddProduct(orderViewProduct: IOrderHistoryViewProduct): boolean {
		return orderViewProduct.canAddToCart && !!orderViewProduct.id && orderViewProduct.id > 0;
	}

	handleProductAddedAlert(hasUnavailableProducts: boolean, addedProducts: IProductLine[]) {
		if (addedProducts.length == 1) {
			this.alertUtilService.alertAddedToCartWithQuantity(addedProducts[0].product, addedProducts[0].quantity);
		} else {
			this.alertUtilService.addSuccess({body: "cart.products.added", translate: true});
		}

		if (hasUnavailableProducts) {
			this.alertUtilService.addWarning({body: "cart.some.products.not.added", translate: true});
		}
	}
}
